import { render, staticRenderFns } from "./AvenantList.vue?vue&type=template&id=e6205bde&scoped=true"
import script from "./AvenantList.vue?vue&type=script&lang=ts"
export * from "./AvenantList.vue?vue&type=script&lang=ts"
import style0 from "./AvenantList.vue?vue&type=style&index=0&id=e6205bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6205bde",
  null
  
)

export default component.exports